import Footer from "../Common/Footer";
import Header from "../Common/Header";
import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import axios from "axios";
import { ApiContext } from "../Context/Context";
import { use, useContext, useEffect } from "react";
import { getRecords, PostRecords, getRecords_new } from "../Services/ApiCall";
import FeaturedProperty from "../Common/FeaturedProperties";
import Projects from "../Common/Projects";
import NearByProperties from "../Common/NearByProperties";
import {
  BaseUrl,
  staticToken,
  Authorization_Token,
  LoggedInUserID,
  LoggedInUserName,
  setLogindata,
  setUserdata,
} from "../Services/Urls";
import FilterParams from "../Classes/FilterParams";
import { useNavigate } from "react-router-dom";
import {
  buildFilterString,
  getWishList_new,
  getSearchData,
} from "../Services/Helper";
import { useState } from "react";
import { TailSpin } from "react-loader-spinner";
import SidebarFilter from "../Common/SidebarFilter";
import { Drawer } from "@mui/material";
import { callApi } from "../Services/ApiService";
import LoginDialog from "../Common/LoginDialog";

function ViewAllListing() {
  const navigate = useNavigate();
  const {
    logindata,
    setlogindata,
    userData,
    setuserData,
    coordinates,
    setcoordinates,

    searchData,
    setsearchData,
    wishlist,
    setWishlist,  
  } = useContext(ApiContext);
  const [open, setOpen] = useState(false);

  const location = useLocation();
  const initialFilters = location?.state?.filters || new FilterParams();
  

  const [filters, setFilters] = useState(initialFilters);
  const [openLogin, setOpenLogin] = useState(false);
  const params = new URLSearchParams(location.search);
  const tabID = params.get("tabID");
  // const filters = location?.state?.filters;
     const [selectedItems, setSelectedItems] = useState(location?.state?.selectedItems ?? []);
    /// console.log("selectedItems",selectedItems)

  const [data, setdata] = useState([]);
  const [sort, setSort] = useState("");
  const [order, setOrder] = useState(-1);

  const [Loading, setLoading] = useState(true);

  useEffect(() => {
    getSearchResults(filters);
    window.scrollTo(0, 0);
  }, [filters, sort, order]);

  //console.log("Filters:", filters);

  const getSearchResults = async (filters) => {
    // debugger;
    setLoading(true);

    let mongoFilterString;

    if (filters?.wishlist == true) {
      const wishlistData = await getWishList_new();

      const wishlist = wishlistData
        ?.filter(
          (item) =>
            item.VerticalID === filters?.vertical &&
            item.PropertyTypeID === filters?.propertyType,
        )
        ?.map((item) => item.ListingID)
        ?.join(",");

      console.log("wishlist", wishlist);

      let additionalfilters = buildFilterString(filters);

      mongoFilterString = ` 'ListingID': { $in: [${wishlist}] }${
        additionalfilters ? `, ${additionalfilters}` : ""
      } `;
    } else {
      mongoFilterString = buildFilterString(filters);
    }

    // console.log("Mongo Filter String:", mongoFilterString);

    const tabID_ =
      filters?.propertyType === 1 && filters?.vertical === 1
        ? 384
        : filters?.propertyType === 1 && filters?.vertical === 2
          ? 385
          : filters?.propertyType === 1 && filters?.vertical === 3
            ? 386
            : filters?.propertyType === 2 && filters?.vertical === 1
              ? 387
              : 388;

    if (filters?.my != null || filters?.wishlist == true) {
      getRecords_new(
        tabID_,
        1000,
        `{${mongoFilterString}}`,
        1,
        "",
        order,
        sort,
        (res) => {
          // console.log("Search Results:", res);

          if (res.hasErrors === false) {
            if (res?.response?.records != null) {
              setdata(res?.response?.records || []);

              setLoading(false);
            } else {
              setdata([]);
              setLoading(false);
            }
          } else {
            setLoading(false);
          }
        },
      );
    } else {
      const url = `${BaseUrl}/api/CommonAPIs/Getproperties`;

      const jsonBody = {
        pgSize: 1000,
        viewFormat: "columnname",
        filterButtons: "",
        index: 1,
        toEmailID: "admin@dialerp.com",
        tabErpID: tabID,
        useAtlusSearch: false,
        RoleID: 0,
        LedgerID: LoggedInUserID,
        order: order,
        orderBy: sort,
        processID: 1,
        isNew: true,
        filters: `{${mongoFilterString}}`,
      };

      callApi(
        url,
        jsonBody,
        Authorization_Token ? Authorization_Token : staticToken,
        (res) => {
          if (res.hasErrors === false) {
            if (res?.response?.records != null) {
              setdata(res?.response?.records || []);

              setLoading(false);
            } else {
              setdata([]);
              setLoading(false);
            }
          } else {
            setLoading(false);
          }
        },
        (error) => {},
      );
    }
  };

  const getBreadCrumName = () => {
    // console.log(filters);
    if (filters?.wishlist == true) {
      return "My Wishlist";
    } else if (filters?.my != null) {
      return "My Listings";
    } else {
      return selectedItems?.length == 0  ? "Properties" : `Properties in ${selectedItems?.map((item) => item?.ResultName)}`; ;
    }
  };

  // const getSearchResults = (filters) => {
  //   // debugger;
  //   setLoading(true);

  //   let mongoFilterString;

  //   if (filters?.wishlist == true) {
  //     const wishlist = getWishList()
  //       ?.filter(
  //         (item) =>
  //           item.VerticalID === filters?.vertical &&
  //           item.PropertyTypeID === filters?.propertyType,
  //       )
  //       ?.map((item) => item.ListingID)
  //       ?.join(",");

  //     mongoFilterString = `'${"ListingID"}':{$in:[${wishlist}]}`;
  //   } else {
  //     mongoFilterString = buildFilterString(filters);
  //   }

  //   // console.log("Mongo Filter String:", mongoFilterString);

  //   const tabID_ =
  //     filters?.propertyType === 1 && filters?.vertical === 1
  //       ? 384
  //       : filters?.propertyType === 1 && filters?.vertical === 2
  //         ? 385
  //         : filters?.propertyType === 1 && filters?.vertical === 3
  //           ? 386
  //           : filters?.propertyType === 2 && filters?.vertical === 1
  //             ? 387
  //             : 388;
  // };

  // console.log("Filters in ViewAllListing:", tabID, filters);
  return (
    <>
      <div className="page-wrapper">
        <Header
          displaySearch={true}
          filters={filters}
          tabID={tabID}
          onChange={setFilters}
        />

        <div className="content-wrapper">
          {/* <div className="breadcrumb-wrap bg-f br-1">
          <div className="container">
            <div className="breadcrumb-title">
              <h2>Feassssured Properties</h2>
            </div>
          </div>
        </div> */}

          <div
            style={{ marginTop: 100, marginBottom: -40 }}
            className="container"
          >
            <div className="row">
              <div className="col-md-12">
                <div className="breadcrumb-title pt-10 pb-10">
                  <ul className="breadcrumb-menu list-style">
                    <li onClick={() => navigate("/")}>Home</li>
                    <li onClick={{}}>{getBreadCrumName()}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Breadcrumb End */}

          {/* Listing section start */}
          <section className="listing-wrap ptb-50">
            <div className="container">
              <div className="row gx-5">
                <div className="col-xl-3 d-desk">
                  <div className="">
                    <SidebarFilter
                      filters={filters}
                      tabID={tabID}
                      onChange={setFilters}
                    />
                  </div>
                </div>
                <div className="col-xl-9">
                  {/* <div className="headingtop style4 mb-15 d-desk">
                    <div className="row">
                      <div className="fblock topsearch">
                        <div className="form-group">
                          <form className="search-form d-flex">
                            <div className="filter-item-cat">
                              <select
                                style={{
                                  height: 43,
                                  padding: "8px 15px 10px 15px",
                                  border: "1px solid #d3d3d3",
                                  borderRadius: 0,
                                  backgroundColor: "#fff",
                                  borderRight: "none",
                                }}
                              >
                                <option>Buy</option>
                                <option>Rent</option>
                                <option>Commercial</option>
                                <option>PG</option>
                                <option>New Projects</option>
                              </select>
                            </div>

                            <input
                              style={{ borderRadius: 0 }}
                              type="text"
                              placeholder="Search Properties, Location..."
                            />
                            <button
                              onClick={(e) => {
                                e.preventDefault();
                              }}
                              className="btn style2"
                              style={{ padding: "0px 39px 0px 18px" }}
                            >
                             
                              <i
                                class="ri-search-line"
                                style={{
                                  color: "#fff",
                                  display: "block",
                                  marginTop: -3,
                                }}
                              ></i>
                            </button>

                            <button
                              className="btn style2 btnx d-mobile"
                              style={{
                                padding: "0px 39px 0px 14px",
                                marginLeft: 10,
                              }}
                              onClick={(e) => {
                                setOpen(true);
                                e.preventDefault();
                              }}
                            >
                              <i className="ri-filter-3-fill"></i>
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div> */}
                  <div className=" style4 mb-25">
                    <div className="row align-items-center">
                      <div className="col-md-12">
                        <div className="fixheight">
                          <div className="fxmobilediv mb-0">
                            <div className="fixonmobile">
                              <button
                                type="button"
                                className="btn style3 loginbtn d-mobile mb-10"
                                onClick={(e) => {
                                  setOpen(true);
                                  e.preventDefault();
                                }}
                                style={{ width: "100%" }}
                              >
                                {" "}
                                <i
                                  className="ri-filter-3-fill"
                                  style={{ color: "#16a34a" }}
                                ></i>{" "}
                                Filters
                              </button>

                              <div
                                className="profuct-result d-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <p style={{ marginBottom: 0 }}>
                                  {data?.length || 0} Results Found
                                </p>
                                {/* <p>in Noida Sector 62</p> */}
                                <div className="filter-item-cat">
                                  <select
                                    onChange={(e) => {
                                      const value = Number(e.target.value);

                                      if (value === 1) {
                                        setSort("");
                                        setOrder(-1);
                                      } else if (value === 2) {
                                        setSort("Price");
                                        setOrder(-1);
                                      } else if (value === 3) {
                                        setSort("Price");
                                        setOrder(1);
                                      }
                                    }}
                                  >
                                    <option value={1}>Newest First</option>
                                    <option value={2}>
                                      Price : High To Low
                                    </option>
                                    <option value={3}>
                                      Price : Low To High
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    {data?.length > 0 &&
                      data?.map((item, index) => (
                        <FeaturedProperty
                          key={index}
                          {...item}
                          onheartClick={() => setOpenLogin(true)}
                        />
                      ))}
                    {data?.length == 0 && !Loading && (
                      <div className="col-12">
                        <h3>No Properties Found</h3>
                      </div>
                    )}
                    {/* <div className="col-lg-64 col-md-4">
                    <div className="property-card style2">
                      <div className="property-img-slider">
                        <img
                          src="assets/img/property/property-10.jpg"
                          alt="Image"
                        />
                      </div>
                      <div className="property-info">
                        <div className="property-status-wrap">
                          <span className="property-status">For Rent</span>
                          <p className="property-price">
                            $34,900/<span>month</span>
                          </p>
                        </div>
                        <h3>
                          <a href="listing-details.html">Villa In Luis Park</a>
                        </h3>
                        <p>
                          <i className="flaticon-location" />
                          64, 1st Aveneu, High Steet, USA
                        </p>
                        <ul className="property-metainfo list-style">
                          <li>
                            <i className="flaticon-double-bed" />
                            06
                          </li>
                          <li>
                            <i className="flaticon-bath-tub" />
                            04
                          </li>
                          <li>
                            <i className="flaticon-square" />
                            3100 sqft
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div> */}
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Listing section end */}
          {Loading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundColor: "rgba(255,255,255,0.7)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 10,
              }}
            >
              <TailSpin color="#00BFFF" height={80} width={80} />
            </div>
          )}

          <Drawer anchor="bottom" open={open} onClose={() => setOpen(false)}>
            <div className="bottomdrawer" style={{ position: "relative" }}>
              <div className="psticky">
                <h6>Filters</h6>
                {/* Close button */}
                <button
                  onClick={() => setOpen(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    background: "transparent",
                    border: "none",
                    fontSize: "20px",
                    cursor: "pointer",
                    zIndex: 10,
                  }}
                  aria-label="Close"
                >
                  ✕
                </button>
              </div>

              <SidebarFilter
                filters={filters}
                tabID={tabID}
                onChange={setFilters}
              />
            </div>
          </Drawer>
        </div>
        <Footer />
        <LoginDialog
          open={openLogin}
          onClose={() => setOpenLogin(false)}
          onSuccess={(data) => {
            if (data) {
              //  console.log("Login Success:", data);
              setLogindata(data);
              setlogindata(data);

              localStorage.setItem("loginData", JSON.stringify(data));
            }

            //  setUser(data);
          }}
          onUserDetails={(userDetails) => {
            if (userDetails) {
              // console.log("User Details:", userDetails);
              setUserdata(userDetails);
              setuserData(userDetails);
              localStorage.setItem("UserData", JSON.stringify(userDetails));
            }
          }}
        />
      </div>
    </>
  );
}

export default ViewAllListing;
